export const calificaciones = [
    {
        id: 5,
        name: 'Excelente',
        siglas: 'E',
        value: 5
    },
    {
        id: 4,
        name: 'Muy Bueno',
        siglas: 'MB',
        value: 4
    },
    {
        id: 3,
        name: 'Bueno',
        siglas: 'B',
        value: 3
    },
    {
        id: 2,
        name: 'Regular',
        siglas: 'R',
        value: 2
    },
    {
        id: 1,
        name: 'Malo',
        siglas: 'M',
        value: 1
    },
]

export const competencias = [
    {
        id: 1,
        name: 'Administracion del Trabajo'
    },
    {
        id: 2,
        name: 'Cumplimiento con las politicas'
    },
    {
        id: 3,
        name: 'Toma de Decisiones'
    },
    {
        id: 4,
        name: 'Orientacion a los Resultados'
    },
    {
        id: 5,
        name: 'Trabajo en Equipo'
    },
]

export const concienciaCompromiso = [
    {
        id: 6,
        name: 'Puntualidad'
    },
    {
        id: 7,
        name: 'Asistencia'
    },
    {
        id: 8,
        name: 'Adaptacion al cambio'
    },
    {
        id: 9,
        name: 'Integridad'
    },
    {
        id: 10,
        name: 'Actitud'
    },
    {
        id: 11,
        name: 'Comunicación'
    },
    {
        id: 12,
        name: 'Cumplimiento de normas, reglas, reglamento'
    },
    {
        id: 13,
        name: 'Cumple con las ordenes de trabajo'
    },
    {
        id: 14,
        name: 'Mantiene su area limpia'
    },
    {
        id: 15,
        name: 'Cumple con lo que la empresa solicita'
    },
    {
        id: 16,
        name: 'Trabajo en equipo'
    },
]

export const tiempoEntrega = [
    {
        id: 17,
        name: 'Cumplimiento en los tiempos de entrega'
    },
    {
        id: 18,
        name: 'Cumplimiento en la Cantidad de Pedidos'
    },

]

export const resumen = [
    {
        id: 19,
        name: 'Resumen general del desempeño'
    }
]